var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.075 2.3325C0.226227 1.66986 0.597983 1.07822 1.12938 0.654463C1.66078 0.230706 2.32033 -4.57416e-05 3 6.80121e-09H21C21.6797 -4.57416e-05 22.3392 0.230706 22.8706 0.654463C23.402 1.07822 23.7738 1.66986 23.925 2.3325L12 9.621L0.075 2.3325ZM0 4.0455V14.7015L8.7045 9.3645L0 4.0455ZM10.1415 10.245L0.2865 16.2855C0.52999 16.7989 0.91429 17.2326 1.39467 17.5362C1.87505 17.8397 2.43176 18.0005 3 18H21C21.5681 18.0001 22.1246 17.8389 22.6048 17.5351C23.0849 17.2313 23.4688 16.7975 23.712 16.284L13.857 10.2435L12 11.379L10.1415 10.2435V10.245ZM15.2955 9.366L24 14.7015V4.0455L15.2955 9.3645V9.366Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.d4e6dd097cef4c14e12c978e0d722872.svg";
export { ForwardRef as ReactComponent };